import * as React from "react";

function Invoices(props) {
  return (
    <svg width={22} height={23} fill="none" {...props}>
      <rect
        x={1}
        y={1.222}
        width={20}
        height={20}
        rx={2}
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7h9M4 7h1M4 11h1M4 15h1M9 11h9M9 15h9"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const InvoicesIcon = React.memo(Invoices);
export default InvoicesIcon;
